import React from 'react';
import PropTypes from 'prop-types';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var Banner = function Banner(_ref) {
  var _ref$year = _ref.year,
      year = _ref$year === undefined ? new Date().getFullYear() : _ref$year,
      style = _ref.style,
      props = objectWithoutProperties(_ref, ['year', 'style']);
  return React.createElement(
    'a',
    _extends({ href: 'https://hackclub.com/', target: '_blank' }, props),
    React.createElement('img', {
      style: _extends({
        width: '230px',
        position: 'absolute',
        top: '10px',
        left: 0,
        border: 0,
        zIndex: '999'
      }, style),
      src: 'https://hackclub.com/banners/' + year + '.svg',
      alt: 'Hack Club'
    })
  );
};

Banner.propTypes = {
  year: PropTypes.oneOf([2016, 2017, 2018, 2019, 2020, 2021]),
  style: PropTypes.object
};

export default Banner;
//# sourceMappingURL=index.es.js.map
